export default __webpack_public_path__ + "static/media/gamepad_blue_gradient.52d8ddeb.svg";